import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import { MakeCallService} from "foo-framework";

@Component({
  selector: 'app-refund-dialog',
  templateUrl: './refund-dialog.component.html',
  styleUrls: ['./refund-dialog.component.scss']
})
export class RefundDialogComponent implements OnInit {
  form: UntypedFormGroup;
  numDecimalRegex = /^\d*[.,]?\d{0,3}$/;
  currency = '';
  availableAmount: number = 0;
  apiType:string;
  constructor(
    protected fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<any>,
    protected makeCall: MakeCallService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.availableAmount = parseFloat((Number(this.data?.item.amount || 0) - Number(this.data?.item.refunded_amount || 0)).toFixed(2));
    this.initializeForms();
  }

  ngOnInit(): void {
    if (this.data?.item?.currency) this.currency = this.data.item.currency;
    this.apiType = this.data?.type || 'refund';
  }

  initializeForms(): void {
    this.form = this.fb.group({
      amount: [null, [Validators.required, Validators.pattern(this.numDecimalRegex), Validators.max(this.availableAmount)]],
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.makeCall.postRequest('orderhistory/performaction', {
          id: this.data?.item?.id ? this.data.item.id : null,
          void: 0,
          type: this.apiType,
          amount: this.form.get('amount').value,
      }, {
        showLoader: true,
        showSuccessMessage: true
      }).subscribe({
        next: (data) => {
          this.dialogRef.close(true);
        }
      });
    }
  }
}
